import React from "react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Redirect, Link } from "react-router-dom";
import DatabaseList from "./DatabaseList";

function Databases(props) {
  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;

  const renderDatabases = () => {
    const { databases } = props;
    if (databases) {
      return (
        <div className="row">
          <DatabaseList databases={databases} />
        </div>
      );
    }
  };

  return (
    <div className="dashboard container">
      {renderDatabases()}
      <Link
        className="btn-floating btn-large fixed-action-btn green right"
        to="newDatabase"
      >
        <i className="material-icons">add</i>
      </Link>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    databases: state.firestore.ordered.databases,
    auth: state.firebase.auth,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect([
    {
      collection: "databases",
      orderBy: ["alias", "asc"],
    },
  ])
)(Databases);
